function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 2.041C21.16 2.55 26 7.71 26 14c0 6.627-5.373 12-12 12S2 20.627 2 14c0-2.804.962-5.384 2.574-7.427L3.15 5.151A13.942 13.942 0 000 14c0 7.732 6.268 14 14 14s14-6.268 14-14S21.732 0 14 0h-1v6h2V2.041z",
  fill: "#19496B"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12.856 15.31a1.751 1.751 0 102.455-2.454L7.28 6.715a.403.403 0 00-.566.566l6.141 8.03z",
  fill: "#19496B"
});

var SvgReportingKpiTime = function SvgReportingKpiTime(props) {
  return React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgReportingKpiTime;